/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import FileSystemType from '../file/system/file-system-type';

// TODO: Přemístit, to zde ve složce session nemá co dělat, když se to nyní používá v Session i v ContentInfo.
// Otázkou je ale kde, ale zřejmě ke komunikátorům.
/**
 * Utilitární třída pro pomoc při parsování řetezce pro výběr úložiště.
 */
export default class StorageTypesParser {
  /**
   * Naparsuje řetězec priorit úložiště do dvou rozměrného pole.
   * @param {string} storageString
   * @returns {FileSystemType[][]}
   */
  static parse(storageString) {
    return storageString
      .split(';')
      .map((group) => group.split('|'))
      .map((units) =>
        units.flatMap(
          /**
           * @param {string} unit
           * @returns {[] | [FileSystemType]}
           */
          (unit) => {
            switch (unit.trim()) {
              case 'internal':
                return [FileSystemType.Internal];
              case 'usb':
                return [FileSystemType.Usb];
              case 'sdcard':
                return [FileSystemType.SdCard];
              default:
                return [];
            }
          }
        )
      );
  }

  /**
   * Převede dvou rozměrné pole s na řetězec priorit úložiště.
   * @param {FileSystemType[][]} storageTypes
   * @returns {string}
   */
  static toString(storageTypes) {
    return storageTypes.map((arr) => arr.join('|')).join(';');
  }
}
